import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=5ccedd80&"
import script from "./MainFrame.vue?vue&type=script&lang=ts&"
export * from "./MainFrame.vue?vue&type=script&lang=ts&"
import style0 from "./MainFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports